/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateClaimAccess200ResponseData } from './UpdateClaimAccess200ResponseData';
import {
    UpdateClaimAccess200ResponseDataFromJSON,
    UpdateClaimAccess200ResponseDataFromJSONTyped,
    UpdateClaimAccess200ResponseDataToJSON,
    UpdateClaimAccess200ResponseDataToJSONTyped,
} from './UpdateClaimAccess200ResponseData';

/**
 * 
 * @export
 * @interface UpdateClaimAccess200Response
 */
export interface UpdateClaimAccess200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClaimAccess200Response
     */
    success: boolean;
    /**
     * 
     * @type {UpdateClaimAccess200ResponseData}
     * @memberof UpdateClaimAccess200Response
     */
    data: UpdateClaimAccess200ResponseData;
}

/**
 * Check if a given object implements the UpdateClaimAccess200Response interface.
 */
export function instanceOfUpdateClaimAccess200Response(value: object): value is UpdateClaimAccess200Response {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateClaimAccess200ResponseFromJSON(json: any): UpdateClaimAccess200Response {
    return UpdateClaimAccess200ResponseFromJSONTyped(json, false);
}

export function UpdateClaimAccess200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClaimAccess200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'data': UpdateClaimAccess200ResponseDataFromJSON(json['data']),
    };
}

export function UpdateClaimAccess200ResponseToJSON(json: any): UpdateClaimAccess200Response {
    return UpdateClaimAccess200ResponseToJSONTyped(json, false);
}

export function UpdateClaimAccess200ResponseToJSONTyped(value?: UpdateClaimAccess200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': UpdateClaimAccess200ResponseDataToJSON(value['data']),
    };
}

